import { useEffect } from 'preact/hooks';
import { isDesktopAdmin } from '../store/state';

export function useAdminDesktopClass() {
  useEffect(() => {
    document.body.classList.toggle('admin-desktop', isDesktopAdmin.value);
  }, [isDesktopAdmin.value]);
}
